import { ReactNode } from "react";

// Tipi per il provider
export interface AppProviderProps {
  children: ReactNode;
}

interface Carousel {
  type: string;
  index: number;
}
export interface AppState {
  data: ICOHData | null;
  fetching: boolean;
  error: boolean;
  caroulsels: Carousel[]
}

export interface AppContextProps {
  state: AppState;
  setFetching: (fetching: boolean) => void;
  updateScientificCommittee: (scientificCommittee: string) => void;
}

// Interface per i dettagli del comitato scientifico
export interface ScientificCommittee {
  name: string;
  logo: string;
  description: string;
  keywords: string;
  canonical: string;
}

// Interface per ogni voce del menu
export interface MenuItem {
  label: string;
  link: string;
  index?: number;
  submenu?: MenuItem[];
  pageId?: string;
}

// Interface per il testo HTML e l'elenco dei manager in "about_us"
export interface Manager {
  title: string;
  text: string;
}

// Interface per la sezione "about_us"
export interface AboutUs {
  text: string;
  managers: Manager[];
  sections?: SubSection[];
}

export interface SubSection {
  title: string;
  text: string;
  sections?: SubSection[];
}
interface Item {
  id: number;
  type: ItemType;
  date: string;
  title: string;
  summary: string;
  text: string
  image: Image;
  images: Image[];
  imageOriginal?: string;
  imageThumbnail?: string;
}

interface Attachment {
  name: string;
  link: string;
  type: string;
}

export enum ItemType {
  NEWS = "news",
  PUBLICATION = "publication",
  EVENT = "event",
  GALLERY = "gallery",
}

export interface Image {
  original?: string;
  thumbnail?: string;
  originalAlt?: string;
  description?: string;
}

export interface NewsItem extends Item {}

export interface PublicationItem extends Item {
  attachments?: Attachment[];
}

export interface EventItem extends Item {
  place: string;
  period: string;
  expireDate: string;
  passed?: boolean;
  attachments?: Attachment[];
}

export interface GalleryItem extends Item {
  period: string;
  place: string;
  imageThumbnail: string;
  imageOriginal: string;
  imageAlt: string;
  imageDescription: string;
}

export interface ICOHData {
  scientific_committee: ScientificCommittee;
  menu: MenuItem[];
  about_us: AboutUs;
  news?: NewsItem[];
  events?: EventItem[];
  publications?: PublicationItem[];
  gallery?: GalleryItem[];
  [key: string]: any;
}
